import React from 'react';
import { IEquityHistoryNav } from './IEquityHistoryNav';

export const EquityHistoryNav = (props: IEquityHistoryNav) => {

  return (
    <p>Hello EquityHistoryNav</p>
  );
};

export default EquityHistoryNav;
